import { CaseNoteResponse, ClientDetailResponse } from "@/api";
import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useTranslation } from "@/translations";

import { CaseNoteForm } from "../case-note-form/CaseNoteForm";
import { useCaseNoteEdit } from "./hooks/useCaseNoteEdit";

interface Props {
  client: ClientDetailResponse;
  caseNote: CaseNoteResponse;
  onClose: () => void;
}

export function CaseNoteEditDialog({ client, caseNote, onClose }: Props) {
  const { t } = useTranslation();
  const { formik, typeOptions, locationOptions, resultOptions, appointmentStatusOptions, isConversationType } =
    useCaseNoteEdit(client, caseNote, onClose);

  return (
    <FormDialog
      title={t("clients.client.caseNotes.editDialog.title")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("common.save")}
    >
      <CaseNoteForm
        formik={formik}
        clientId={client.clientId}
        typeOptions={typeOptions}
        locationOptions={locationOptions}
        resultOptions={resultOptions}
        appointmentStatusOptions={appointmentStatusOptions}
        isConversationType={isConversationType}
      />
    </FormDialog>
  );
}
